import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ProjectItemRevisionModel from '../../../models/ProjectItemRevisionModel';
import DataService from "../../../services/data.service";
import { ItemRevisionProps } from '../../../types/IdProps';
import ItemRevision_popup_AddToProject from '../Popups/ItemRevision_popup_AddToProject';
import ItemRevision_popup_MoveToAnotherProject from '../Popups/ItemRevision_popup_MoveToAnotherProject';

interface Props extends ItemRevisionProps {
    onProjectMoved: () => void
}

const ItemRevision_tab_Projects: React.FC<Props> = ({ itemId, itemRevisionId, itemTypeId, onProjectMoved }) => {
    const [data, setData] = useState<ProjectItemRevisionModel[]>();
    const [selectedRow, setSelectedRow] = useState<ProjectItemRevisionModel>()
    const [showMoveToAontherProjectPopup, setShowMoveToAontherProjectPopup] = useState<boolean>(false)
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemRevisionId]);

    function getTableData() {
        DataService.get<ProjectItemRevisionModel[]>('api/v1/ProjectItemRevisions/ByItemRevision/' + itemRevisionId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData: ProjectItemRevisionModel) {
        DataService.delete('api/v1/ProjectItemRevisions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function moveToAnotherProject(rowData: ProjectItemRevisionModel) {
        setSelectedRow(rowData)
        setShowMoveToAontherProjectPopup(true)
    }


    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'projectId', visible: false },
        { title: 'Name', dataProp: 'project', dataType: 'project', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Project type', dataProp: 'project.projectType', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Status', dataProp: 'project.projectStatus', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Business-Partners', dataProp: 'project.businessPartners', filterInfo: { filterType: 'Textbox' } },
        { title: 'Started on', dataProp: 'project.startedOn', dataType: 'date' },
        { title: 'Deadline', dataProp: 'project.deadline', dataType: 'date' },
        { title: 'Finished on', dataProp: 'project.finishedOn', dataType: 'date' },
    ];

    if (isAuthorizedForItemType(ApplicationFunctions.UpdateItem, itemTypeId)) {
        colInfos.push(
            {
                sort: false,
                rowButtons: [{ text: "Move", icon: 'fa-edit', color: 'green', onClick: moveToAnotherProject }]
            });
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowAddPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtItemRevisionProjects'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Project'
                navigateUrl='/plm/Projects/Details/'
            />
            {showAddPopup && <ItemRevision_popup_AddToProject itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={itemTypeId} show={showAddPopup} onHide={() => { setShowAddPopup(false); getTableData(); }} />}
            {showMoveToAontherProjectPopup && selectedRow && <ItemRevision_popup_MoveToAnotherProject projectItemRevision={selectedRow} itemTypeId={itemTypeId} show={showMoveToAontherProjectPopup} onHide={() => { setShowMoveToAontherProjectPopup(false); getTableData(); onProjectMoved(); }} />}
        </>
    );
}
export default ItemRevision_tab_Projects;